/* eslint-disable */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import type { TDocumentDefinitions, Content, Margins } from 'pdfmake/interfaces';
(pdfMake as any).vfs = (pdfFonts as any).vfs;

import { IComprovanteBaixaDados } from './ComprovanteBaixa';

const formatarMoeda = (valor: number) => Number(valor || 0).toFixed(2);

// Mesmo formato 80mm de impressaotermica.ts (PDVSIAC): sem tabelas com
// borda (não rendem bem em papel estreito), só colunas simples e linhas
// tracejadas como separador.
export async function gerarComprovanteBaixaTermica(dados: IComprovanteBaixaDados): Promise<Blob> {
  // `defaultStyle` abaixo referencia a fonte 'Roboto' pelo nome — precisa
  // registrar explicitamente (mesmo padrão de impressaovenda.ts/impressaovenda01.ts/
  // impressaovenda88.ts, os outros geradores pdfmake com defaultStyle.font
  // deste projeto), senão o pdfmake não sabe qual arquivo do vfs usar pra
  // cada variante (normal/bold/...).
  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
  };

  const content: Content[] = [];

  content.push({
    text: dados.contaNome,
    bold: true,
    fontSize: 11,
    alignment: 'center',
    margin: [0, 0, 0, 2],
  });
  content.push({
    text: 'COMPROVANTE DE RECEBIMENTO',
    bold: true,
    fontSize: 9,
    alignment: 'center',
    margin: [0, 0, 0, 4],
  });
  content.push({ text: '-'.repeat(32), alignment: 'center', fontSize: 8, margin: [0, 0, 0, 4] });

  content.push({ text: `Parceiro: ${dados.parceiro}`, fontSize: 8, margin: [0, 0, 0, 1] });
  content.push({ text: `Data: ${moment(dados.datalan).format('DD/MM/YYYY')}`, fontSize: 8, margin: [0, 0, 0, 4] });
  content.push({ text: '-'.repeat(32), alignment: 'center', fontSize: 8, margin: [0, 0, 0, 4] });

  content.push({ text: 'CONTAS BAIXADAS', bold: true, fontSize: 8, margin: [0, 0, 0, 2] });
  dados.contas.forEach((conta) => {
    content.push({
      columns: [
        { width: '*', text: `${conta.numero || '***'}${conta.parcela ? ` (${conta.parcela})` : ''}`, fontSize: 8 },
        { width: 60, text: formatarMoeda(conta.valor), fontSize: 8, alignment: 'right' },
      ],
      margin: [0, 0, 0, 1],
    });
  });
  content.push({ text: '-'.repeat(32), alignment: 'center', fontSize: 8, margin: [0, 4, 0, 4] });

  content.push({ text: 'FORMAS DE PAGAMENTO', bold: true, fontSize: 8, margin: [0, 0, 0, 2] });
  dados.formasPagamento.forEach((forma) => {
    content.push({
      columns: [
        { width: '*', text: forma.nome, fontSize: 8 },
        { width: 60, text: formatarMoeda(forma.valor), fontSize: 8, alignment: 'right' },
      ],
      margin: [0, 0, 0, 1],
    });
  });
  content.push({ text: '-'.repeat(32), alignment: 'center', fontSize: 8, margin: [0, 4, 0, 4] });

  if (dados.acrescimo > 0.005) {
    content.push({
      columns: [
        { width: '*', text: 'ACRÉSCIMO', fontSize: 9 },
        { width: 60, text: formatarMoeda(dados.acrescimo), fontSize: 9, alignment: 'right' },
      ],
      margin: [0, 0, 0, 1],
    });
  }
  if (dados.desconto > 0.005) {
    content.push({
      columns: [
        { width: '*', text: 'DESCONTO', fontSize: 9 },
        { width: 60, text: `-${formatarMoeda(dados.desconto)}`, fontSize: 9, alignment: 'right' },
      ],
      margin: [0, 0, 0, 1],
    });
  }
  content.push({
    columns: [
      { width: '*', text: 'TOTAL RECEBIDO', bold: true, fontSize: 11 },
      { width: 70, text: formatarMoeda(dados.totalBaixado), bold: true, fontSize: 11, alignment: 'right' },
    ],
    margin: [0, 2, 0, 4],
  });

  content.push({ text: '-'.repeat(32), alignment: 'center', fontSize: 8, margin: [0, 0, 0, 4] });
  content.push({
    text: moment().format('DD/MM/YYYY HH:mm:ss'),
    alignment: 'center',
    fontSize: 8,
    margin: [0, 0, 0, 2],
  });
  content.push({
    text: '*** DOCUMENTO SEM VALOR FISCAL ***',
    alignment: 'center',
    bold: true,
    fontSize: 8,
    margin: [0, 2, 0, 2],
  });

  const documentDefinition: TDocumentDefinitions = {
    pageSize: {
      width: 226.77, // 80mm
      height: 'auto' as const,
    },
    pageMargins: [10, 10, 10, 10] as Margins,
    content,
    defaultStyle: {
      font: 'Roboto',
      fontSize: 9,
    },
    compress: true,
  };

  return new Promise((resolve, reject) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
      pdfDocGenerator.getBlob((blob: Blob) => resolve(blob));
    } catch (error) {
      reject(error);
    }
  });
}
